import Vue from 'vue';
export default {
  getProductList(params) {
    return Vue.axios.get('/rx/user/api/v1.0/loan/product/list', { params });
  },
  getUserDetails(params) {
    return Vue.axios.get('/rx/user/api/v1.0/user/detail', { params });
  },
  userIdentity(postData) {
    return Vue.axios.post('/rx/user/api/v1.0/user/identity', postData);
  },
  // 获取图片验证码
  getCaptchaImage() {
    return Vue.axios.get('/api/v1.0/captcha');
  },
  sendSmsByMobile(data) {
    return Vue.axios.post('/api/v1.0/sms', data);
  },
  createOrder(postData) {
    return Vue.axios.post('/rx/user/api/v2.0/loan/application/create', postData);
  },
  // 获取信息资讯列表
  getnewsList(params) {
    return Vue.axios.get('/rx/user/api/v2.0/catalog/list', { params });
  },
  // 获取新闻
  getnews(params) {
    return Vue.axios.get('/rx/user/api/v2.0/news/list', { params });
  },
  // 获取信息资讯详情
  getnewsDetail(params) {
    return Vue.axios.get('/rx/user/api/v2.0/news/detail', { params });
  },
  // 合作机构
  getcompany(params) {
    return Vue.axios.get('/rx/user/api/v1.0/company/partner/list', { params });
  },
  // 注册企业
  getEffectiveCount() {
    return Vue.axios.get('/api/v1.0/chanquan/user/getEffectiveCount');
  },
  application() {
    return Vue.axios.get('/rx/user/api/v1.0/loan/application/total-loaded-amount');
  }
};
